<template>
  <button class="btn" :class="`btn--${size}`" @click="onClick">
    <slot>{{ text }}</slot>
  </button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: 'regular',
      validator: value => ['regular', 'small'].includes(value)
    }
  },
  methods: {
    onClick() {
      this.$emit('click-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn {
  width: 100%;
  font-weight: bold;
  cursor: pointer;
  box-sizing: border-box;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
  line-height: normal;
  color: $white;
  border-radius: 100px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &--regular {
    height: 48px;
    padding: 16px;
    font-size: 1.6rem;
  }

  &--small {
    height: 40px;
    padding: 12px;
    font-size: 1.2rem;
  }

  %disabled-common {
    background-color: $gray-2;
    color: $gray-1;
  }

  &:disabled {
    @extend %disabled-common;
    cursor: default;
    border: 0;
  }

  &[disabled]:hover {
    @extend %disabled-common;
    opacity: 100%;
  }

  @media (hover: hover) {
    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
